import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaiairportdropinnova() {



  const cardData = {


  keyword: "Pune to Mumbai Airport Drop Innova",

  headingDescription: "Trustline Travels offers reliable Pune to Mumbai Airport Drop Innova services with spacious, comfortable, and chauffeur-driven vehicles for domestic and international airport transfers. Whether you are traveling for business, family vacations, corporate travel, or carrying extra luggage, our Toyota Innova provides a smooth and comfortable journey from Pune to Mumbai Airport. Our experienced drivers ensure timely pickups, flight-friendly scheduling, safe travel, and hassle-free airport drop services. With transparent pricing, doorstep pickup, easy online booking, well-maintained vehicles, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Mumbai Airport Innova taxi services.",

topPlaces: [
  {
    title: "Chhatrapati Shivaji Maharaj International Airport",
    description: "Mumbai's primary international airport and one of India's busiest aviation hubs, serving millions of domestic and international passengers every year."
  },
  {
    title: "Terminal 1",
    description: "Terminal 1 is the domestic terminal at Mumbai Airport, serving passengers traveling to major cities and destinations across India."
  },
  {
    title: "Terminal 2",
    description: "Terminal 2 is Mumbai Airport's modern integrated terminal handling international and domestic flights with world-class passenger facilities."
  },
  {
    title: "Mumbai Airport Arrivals",
    description: "The arrivals area at Mumbai Airport provides baggage claim, customs, immigration, passenger assistance, and transportation facilities for arriving travelers."
  },
  {
    title: "Mumbai Airport Departures",
    description: "The departures area at Mumbai Airport provides check-in counters, security screening, boarding facilities, lounges, dining, and retail services."
  },
  {
    title: "Mumbai Airport International Terminal",
    description: "The international terminal provides immigration, customs, premium lounges, duty-free shopping, dining, and passenger services for international travelers."
  },
  {
    title: "Mumbai Airport Domestic Terminal",
    description: "The domestic terminal provides check-in, security, boarding, baggage, dining, and other essential services for passengers flying within India."
  },
  {
    title: "Mumbai Airport Lounges",
    description: "Mumbai Airport offers premium passenger lounges with comfortable seating, refreshments, Wi-Fi, business facilities, and other travel amenities."
  },
  {
    title: "Mumbai Airport Duty Free",
    description: "Mumbai Airport's duty-free shopping area offers international travelers a selection of luxury products, cosmetics, electronics, gifts, and travel essentials."
  },
  {
    title: "Mumbai Airport Parking",
    description: "Mumbai Airport provides dedicated parking facilities for passengers and visitors, offering convenient options for short-term and long-term vehicle parking."
  }
],






"services": [
  {
    "name": "Pune to Mumbai Airport Drop Innova",
    "description": "Book Pune to Mumbai Airport Drop Innova for comfortable airport transfers with experienced drivers, spacious seating, fixed fares, and doorstep pickup."
  },
  {
    "name": "Pune to Mumbai Airport Innova",
    "description": "Hire Pune to Mumbai Airport Innova for premium airport travel with clean AC vehicles, professional chauffeurs, and reliable service."
  },
  {
    "name": "Mumbai Airport to Pune Innova",
    "description": "Book Mumbai Airport to Pune Innova for convenient airport pickup with comfortable seating, ample luggage space, and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Airport Drop Innova",
    "description": "Choose Pune to Mumbai Airport Drop Innova service for on-time airport drop with transparent pricing and comfortable travel."
  },
  {
    "name": "Pune to Mumbai Airport Innova Cab",
    "description": "Book Pune to Mumbai Airport Innova Cab for one-way, round-trip, and airport transfer services with professional chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport Innova Taxi",
    "description": "Travel with Pune to Mumbai Airport Innova Taxi offering spacious interiors, fixed fares, and reliable airport transportation."
  },
  {
    "name": "Pune to Mumbai Airport Innova Cab Service",
    "description": "Choose Pune to Mumbai Airport Innova Cab Service for safe airport transfers, business travel, and family trips."
  },
  {
    "name": "Pune to Mumbai Airport Cab",
    "description": "Book Pune to Mumbai Airport Cab with Sedan, Ertiga, Innova Crysta, and SUV options for comfortable airport travel."
  },
  {
    "name": "Pune to Mumbai Airport Taxi",
    "description": "Hire Pune to Mumbai Airport Taxi with experienced drivers, AC vehicles, and timely pickup for domestic and international terminals."
  },
  {
    "name": "Pune to Mumbai Airport Cab Booking",
    "description": "Reserve Pune to Mumbai Airport Cab Booking online with instant confirmation and 24x7 customer support."
  },
  {
    "name": "Pune to Mumbai Airport Taxi Booking",
    "description": "Book Pune to Mumbai Airport Taxi Booking easily with fixed pricing and professional chauffeur service."
  },
  {
    "name": "Innova Cab Pune to Mumbai Airport",
    "description": "Hire an Innova Cab Pune to Mumbai Airport for family travel, corporate transfers, and airport drop services."
  },
  {
    "name": "Innova Crysta Pune to Mumbai Airport",
    "description": "Choose Innova Crysta Pune to Mumbai Airport for premium comfort, spacious seating, and luxury airport transportation."
  },
  {
    "name": "Pune to Mumbai Airport SUV Cab",
    "description": "Book Pune to Mumbai Airport SUV Cab for group travel, business trips, and comfortable long-distance airport transfers."
  },
  {
    "name": "Pune to Mumbai Airport Car Rental",
    "description": "Choose Pune to Mumbai Airport Car Rental with chauffeur-driven vehicles and flexible travel options."
  },
  {
    "name": "Pune to Mumbai Airport Private Cab",
    "description": "Hire a Pune to Mumbai Airport Private Cab for exclusive travel with personalized pickup and drop service."
  },
  {
    "name": "Pune to Mumbai Airport Transfer",
    "description": "Book Pune to Mumbai Airport Transfer for punctual airport transportation with experienced drivers and AC vehicles."
  },
  {
    "name": "Pune to Mumbai Airport Drop Cab",
    "description": "Reserve Pune to Mumbai Airport Drop Cab for reliable and affordable airport drop services available 24x7."
  },
  {
    "name": "Pune to Mumbai Airport AC Cab",
    "description": "Travel comfortably with Pune to Mumbai Airport AC Cab featuring clean vehicles and professional chauffeurs."
  },
  {
    "name": "Pune to Mumbai Airport Intercity Cab",
    "description": "Book Pune to Mumbai Airport Intercity Cab for smooth highway travel with fixed fares and doorstep pickup."
  },
  {
    "name": "Pune to Mumbai Airport Luxury Cab",
    "description": "Choose Pune to Mumbai Airport Luxury Cab for premium airport transfers with luxury vehicles and experienced drivers."
  },
  {
    "name": "Pune to Mumbai Airport Premium Cab",
    "description": "Hire Pune to Mumbai Airport Premium Cab for executive travel, family trips, and airport transportation."
  },
  {
    "name": "Hinjewadi to Mumbai Airport Innova Cab",
    "description": "Book Hinjewadi to Mumbai Airport Innova Cab for corporate travel, airport transfers, and comfortable family journeys."
  },
  {
    "name": "Wakad to Mumbai Airport Innova Cab",
    "description": "Choose Wakad to Mumbai Airport Innova Cab with spacious seating, AC comfort, and professional chauffeur service."
  },
  {
    "name": "Baner to Mumbai Airport Innova Cab",
    "description": "Book Baner to Mumbai Airport Innova Cab for reliable airport transfers with fixed pricing and clean vehicles."
  },
  {
    "name": "Kharadi to Mumbai Airport Innova Cab",
    "description": "Hire Kharadi to Mumbai Airport Innova Cab for business travel, airport pickup, and drop services."
  },
  {
    "name": "Hadapsar to Mumbai Airport Innova Cab",
    "description": "Book Hadapsar to Mumbai Airport Innova Cab for safe, comfortable, and affordable airport transportation."
  },
  {
    "name": "Pimpri Chinchwad to Mumbai Airport Innova Cab",
    "description": "Choose Pimpri Chinchwad to Mumbai Airport Innova Cab for one-way airport transfers with experienced drivers."
  },
  {
    "name": "Viman Nagar to Mumbai Airport Innova Cab",
    "description": "Book Viman Nagar to Mumbai Airport Innova Cab for quick airport pickup, drop, and corporate travel."
  },
  {
    "name": "Kothrud to Mumbai Airport Innova Cab",
    "description": "Hire Kothrud to Mumbai Airport Innova Cab for premium airport transfers with spacious luggage capacity."
  },
  {
    "name": "Aundh to Mumbai Airport Innova Cab",
    "description": "Reserve Aundh to Mumbai Airport Innova Cab for comfortable airport travel with professional drivers."
  },
  {
    "name": "Shivajinagar to Mumbai Airport Innova Cab",
    "description": "Book Shivajinagar to Mumbai Airport Innova Cab for reliable airport transfer services with clean AC vehicles."
  }
],

"tableData": [
  ["Pune to Mumbai Airport Drop Innova", "Pune to Mumbai Airport Innova"],
  ["Mumbai Airport to Pune Innova", "Pune to Mumbai Airport Innova Cab"],
  ["Pune to Mumbai Airport Innova Taxi", "Pune to Mumbai Airport Innova Cab Service"],
  ["Pune to Mumbai Airport Cab", "Pune to Mumbai Airport Taxi"],
  ["Pune to Mumbai Airport Cab Booking", "Pune to Mumbai Airport Taxi Booking"],
  ["Innova Cab Pune to Mumbai Airport", "Innova Crysta Pune to Mumbai Airport"],
  ["Pune to Mumbai Airport SUV Cab", "Pune to Mumbai Airport Car Rental"],
  ["Pune to Mumbai Airport Private Cab", "Pune to Mumbai Airport Transfer"],
  ["Pune to Mumbai Airport Drop Cab", "Pune to Mumbai Airport AC Cab"],
  ["Pune to Mumbai Airport Intercity Cab", "Pune to Mumbai Airport Luxury Cab"],
  ["Pune to Mumbai Airport Premium Cab", "Hinjewadi to Mumbai Airport Innova Cab"],
  ["Wakad to Mumbai Airport Innova Cab", "Baner to Mumbai Airport Innova Cab"],
  ["Kharadi to Mumbai Airport Innova Cab", "Hadapsar to Mumbai Airport Innova Cab"],
  ["Pimpri Chinchwad to Mumbai Airport Innova Cab", "Viman Nagar to Mumbai Airport Innova Cab"],
  ["Kothrud to Mumbai Airport Innova Cab", "Aundh to Mumbai Airport Innova Cab"],
  ["Shivajinagar to Mumbai Airport Innova Cab", "Pune to Mumbai Airport Drop Innova"]
],





whychoose: [
  {
    WhyChooseheading: "Premium Pune to Mumbai Airport Drop Innova Service",
    WhyChoosedescription: "Trustline Travels offers comfortable Innova cab services from Pune to Mumbai Airport with timely pickups and reliable airport transfers."
  },
  {
    WhyChooseheading: "Guaranteed On-Time Airport Drop",
    WhyChoosedescription: "Our drivers plan the journey carefully to ensure you reach Mumbai Airport well before your flight departure."
  },
  {
    WhyChooseheading: "Spacious Innova for Comfortable Travel",
    WhyChoosedescription: "Travel in a well-maintained Toyota Innova with spacious seating and ample luggage capacity for a relaxing airport journey."
  },
  {
    WhyChooseheading: "Professional Airport Chauffeurs",
    WhyChoosedescription: "Our experienced drivers are familiar with Mumbai Airport routes and provide safe, punctual, and hassle-free transfers."
  },
  {
    WhyChooseheading: "Transparent Fare with No Hidden Charges",
    WhyChoosedescription: "Enjoy competitive Innova airport transfer rates with upfront pricing and complete fare transparency."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We provide pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major locations in Pune."
  },
  {
    WhyChooseheading: "24/7 Airport Transfer Availability",
    WhyChoosedescription: "Whether your flight is early morning or late at night, our Innova airport drop service is available around the clock."
  },
  {
    WhyChooseheading: "Quick Booking & Instant Confirmation",
    WhyChoosedescription: "Book your Pune to Mumbai Airport Innova easily with instant quotations, fast confirmations, and dedicated customer support."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Mumbai Airport Drop Innova service?",
    answer: "Yes, Trustline Cab offers reliable Innova airport drop services from Pune to Mumbai Airport for individuals, families, and corporate travelers."
  },
  {
    question: "Can I book an Innova for Mumbai Airport Terminal 1 and Terminal 2?",
    answer: "Yes, we provide direct airport drop services to both Mumbai Airport Terminal 1 and Terminal 2."
  },
  {
    question: "Is the Toyota Innova suitable for airport transfers?",
    answer: "Yes, the Toyota Innova is an excellent choice for airport transfers due to its spacious seating and generous luggage capacity."
  },
  {
    question: "Do you provide doorstep pickup in Pune?",
    answer: "Yes, we offer pickup from homes, offices, hotels, Pune Airport, Pune Railway Station, and all major areas across Pune."
  },
  {
    question: "Can I book a one-way Innova airport drop?",
    answer: "Yes, affordable one-way Innova airport transfer services are available from Pune to Mumbai Airport."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically mentioned in the booking quotation."
  },
  {
    question: "Is the Innova airport service available 24/7?",
    answer: "Yes, Trustline Cab provides Innova airport transfer services throughout the day and night."
  },
  {
    question: "Should I reserve my airport cab in advance?",
    answer: "Yes, advance booking is recommended to ensure vehicle availability and timely pickup according to your flight schedule."
  },
  {
    question: "Do you provide airport transfers for business travelers?",
    answer: "Yes, our Innova airport cab service is ideal for corporate executives, families, tourists, and frequent flyers."
  },
  {
    question: "How can I book a Pune to Mumbai Airport Drop Innova with Trustline Travels?",
    answer: "Simply share your pickup location, flight timing, travel date, passenger count, and destination to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Kiran Patwardhan",
    feedback: "I booked an Innova from Pune to Mumbai Airport through Trustline Travels for my international flight. The driver arrived before time, the vehicle was spacious, and I reached the airport comfortably without any stress.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sonali Deshmukh",
    feedback: "Our family airport transfer was perfectly managed by Trustline Travels. The Innova was clean, offered plenty of luggage space, and the driver ensured we reached Mumbai Airport safely and on time.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Airport Drop Innova Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-airport-drop-innova.webp",
  "description": "Book Pune to Mumbai Airport Drop Innova cab service with Trustline Travels for comfortable and reliable airport transfers. Get premium Innova taxi services from Pune to Mumbai Airport with experienced drivers available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6942"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹16/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-airport-drop-innova"
  }
};






  return (
    <div>
<Helmet>
  <title>Pune to Mumbai Airport Drop Innova | Airport Taxi | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai Airport Drop Innova cab with Trustline Travels for safe and comfortable airport travel. Enjoy premium Innova taxi service from Pune to Mumbai Airport with professional drivers and 24x7 availability."
  />

  <meta
    name="keywords"
    content="Pune to mumbai airport drop innova, Pune to mumbai airport innova, Mumbai airport to pune innova, Pune to Mumbai Airport Drop Innova, Pune to Mumbai Airport Innova Cab, Pune to Mumbai Airport Innova Taxi, Pune to Mumbai Airport Innova Service, Pune Mumbai airport Innova booking, Pune to Mumbai Airport Crysta Innova, Pune airport to Mumbai airport taxi, Pune Mumbai airport drop cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/68.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaiairportdropinnova;